<template lang="pug">
  component(
    v-if='component && artist'
    :is='component'
    :artist='artist'
    :running='artistRunning'
    @play='play'
    @pause='pause'
    @like='likeArtist'
    @unlike='unlikeArtist'
  )
</template>

<script>
import { mapActions } from "vuex";

import playerControlsMixin from "@/mixins/shared/playerControls.mixin";
import dinamicComponentMixin from "@/mixins/shared/dinamicComponent.mixin";

import cardTemplate from "./templates/card";
import fullTemplate from "./templates/full";

export default {
  props: {
    artist: Object
  },
  data() {
    return {
      tracklist: {
        owner: true,
        id: this.artist.id,
        tracks: this.artist.tracks || []
      },
      templates: {
        card: cardTemplate,
        full: fullTemplate
      }
    };
  },
  mixins: [playerControlsMixin, dinamicComponentMixin],
  computed: {
    artistRunning() {
      return Boolean(
        this.running &&
          this.currentPlaylist &&
          this.currentPlaylist.id === this.artist.id
      );
    }
  },
  methods: {
    ...mapActions({
      like: "artists/like",
      unlike: "artists/unlike"
    }),
    likeArtist() {
      this.like(this.artist.id);
    },
    unlikeArtist() {
      this.unlike(this.artist.id);
    }
  }
};
</script>
